import { Classification, FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';
import { ReactNode, useEffect, useMemo } from 'react';

interface ClassificationsFilterProps {
    classifications: Classification[];
    fetchClassifications?: () => void;
}

export const ClassificationsFilter = (props: ClassificationsFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    useEffect(() => {
        props.fetchClassifications?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options: SelectOption[] = useMemo(
        () =>
            props.classifications.map(classification => ({
                displayValue: classification.name,
                value: classification.id,
            })),
        [props.classifications]
    );

    const onSelected = (classificationId?: number) => {
        filter.delete(FilterParams.Classifications);
        if (classificationId) {
            filter.set(FilterParams.Classifications, classificationId.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (value: unknown): ReactNode => {
        if (typeof value !== 'string') {
            return '';
        }

        const classificationId = +value;
        const classification = props.classifications.find(c => c.id === classificationId);
        return classification?.name;
    };

    registerFilterMap(FilterParams.Classifications, getDisplayValue);

    return (
        <PoolSelect
            displayEmpty={true}
            name="classification"
            label={<FormattedMessage id="app.filter.classification" />}
            fullWidth={true}
            value={filter.get(FilterParams.Classifications)}
            onValueChange={onSelected}
            noSorting={true}
            options={options}
        />
    );
};
